import React, { FC, useMemo } from 'react'
import styled from 'styled-components'

import { SanityAccountDashboardPageFragment } from '../../../../graphql/gatsby'
import useSiteSettings from '../../../../hooks/useSiteSettings'
import useUserCategory from '../../../../hooks/useUserCategory'
import { langCodes } from '../../../../utils/siteSettings'
import { RewardsDashboard } from '../rewards/dashboard/RewardsDashboard'
import { RewardsOnboardingServiceProvider } from '../rewards/onboarding/RewardsOnboardingServiceProvider'
import RecentOrdersContainer from './RecentOrdersContainer'

export interface DashboardProps {
  className?: string
  sanityAccountDashboardPage: SanityAccountDashboardPageFragment['sanityAccountDashboardPage']
}

const Dashboard: FC<DashboardProps> = ({ className, sanityAccountDashboardPage }) => {
  const { lang } = useSiteSettings()
  const { userCategory } = useUserCategory()
  const showRewards = useMemo(
    () => lang === langCodes.en_US && userCategory === 'practitioner',
    [lang, userCategory],
  )

  return (
    <div className={className}>
      {showRewards ? (
        <RewardsOnboardingServiceProvider>
          <RewardsDashboard sanityAccountDashboardPage={sanityAccountDashboardPage} />
        </RewardsOnboardingServiceProvider>
      ) : (
        <RecentOrdersContainer />
      )}
    </div>
  )
}

const StyledDashboard = styled(Dashboard)({
  '.most-recent-orders': {
    marginBottom: '17px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    a: {
      fontSize: '14px',
      textAlign: 'end',
    },
    h3: {
      marginBottom: '0',
    },
  },
})

export default StyledDashboard
